var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSvgKurumsalIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 45.057 45.057",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x35_7_27_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.431,0H5.179v45.057h34.699V6.25L33.431,0z M36.878,42.056H8.179V3h23.707v4.76h4.992V42.056L36.878,42.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.529,21.595v-1.814h-3.75v1.814c0,2.888,0,5.772,0,8.66v1.875h0.127h1.748c0.625,0,1.25,0,1.875,0 c1.897,0,3.794,0,5.691,0h1.812V28.3h-7.503C17.529,26.066,17.529,23.83,17.529,21.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.784,14.027H19.93v3.846h7.852c0,2.244,0,4.488,0,6.733c0,0.002,0.002,0.006,0.002,0.01v1.803h3.748v-1.812 c0-2.888,0-5.776,0-8.663v-1.916H27.784L27.784,14.027z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSvgKurumsalIdentity);
export default __webpack_public_path__ + "static/media/ico_svg_kurumsal_identity.d3880a42f835493069707d4409187694.svg";
export { ForwardRef as ReactComponent };